import { render, staticRenderFns } from "./giveawayModal.vue?vue&type=template&id=4da07342&scoped=true"
import script from "./giveawayModal.vue?vue&type=script&lang=ts"
export * from "./giveawayModal.vue?vue&type=script&lang=ts"
import style0 from "./giveawayModal.vue?vue&type=style&index=0&id=4da07342&prod&lang=css"
import style1 from "./giveawayModal.vue?vue&type=style&index=1&id=4da07342&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da07342",
  null
  
)

export default component.exports